import { createContext, useContext, useEffect, useState } from "react";

const content = {
  it: {
    home: {
      title: "La creatività umana sfida l'intelligenza artificiale.",
    },
    nav: {
      about: "Il Manoscritto",
      identity: "Identità",
      mission: "Mission",
      donations: "Donazioni",
      roadmap: "Roadmap",
      pioneers: "Pionieri",
      funds: "Fondi",
      faq: "FAQ",
      team: "Team",
      contract: "Smart Contract",
      tokenomics: "Tokenomics",
      cta: "Diventa Pioniere",
    },
    hero: {
      eyebrow: "Universe Score Token Protocol · Token del mercato regolamentato",
      line1: "Una musica scritta",
      line2: "a mano diventa",
      line3accent: "Speranza e Consapevolezza.",
      sub: "«Universe» è una composizione musicale depositata il 4 aprile 2025. Il suo Token, USTP, sfida l'intelligenza artificiale a provare ciò che solo un essere umano può provare.",
      badge: "La battaglia ha inizio",
      ctaPioneer: "Diventa Pioniere",
      ctaScore: "Scarica la partitura",
      stats: [
        { v: "70.000.000.000", l: "Total Supply USTP" },
        { v: "7.000.000.000", l: "Token per i Pionieri" },
        { v: "N. 22562423", l: "Protocollo di deposito" },
        { v: "04 · 04 · 2025", l: "Data del manoscritto" },
      ],
    },
    marquee: [
      "Speranza",
      "Consapevolezza",
      "Creatività",
      "Anima umana",
      "Musica originale",
      "La battaglia ha inizio",
      "Arte contro algoritmi",
    ],
    banner: {
      warning: "I Token Pionieri stanno per esaurirsi! Restano solo {remaining} USTP su 7.000.000.000: diventa Pioniere prima del numero chiuso.",
      critical: "Ultimi Token Pionieri disponibili! Restano solo {remaining} USTP: a numero chiuso non ne verranno emessi altri.",
      cta: "Diventa Pioniere ora",
    },
    about: {
      eyebrow: "Il Manoscritto",
      title: "Che cos'è Universe (USTP)?",
      p1: "«Universe» è una composizione musicale, scritta a mano con una matita su carta pentagrammata.",
      p2: "Si tratta di un manoscritto che porta in sé i tratti di ogni singolo essere umano: le emozioni, i sentimenti.",
      p3: "Questo brano è una musica strumentale, è stato messo su carta il 4 aprile 2025 e depositato con il numero di protocollo 22562423 nella stessa data.",
      p4: "La partitura di Universe è stata successivamente rivisitata e migliorata al fine di renderla ben leggibile.",
      scoreLead: "Eccola,",
      scoreLink: "la trovi qui",
      depositLabel: "Deposito",
      depositValue: "N. 22562423",
      dateLabel: "Messo su carta",
      dateValue: "4 aprile 2025",
      tokenTitle: "Il Token USTP",
      p5: "Il Token USTP a cui fa riferimento Universe ha una sua cronologia ed una sua personale visione delle cose, si suppone piuttosto condivisa, ispirata dall'avvento e dallo sviluppo purtroppo galoppante dell'intelligenza artificiale, creata dall'uomo stesso, che minaccia l'espressione della creatività e che secondo «Universe» non sarà mai in grado di dare delle emozioni comparabili a quelle che solo un essere umano in carne ed ossa sa dare.",
      p6: "USTP sta cercando di creare delle connessioni e sinergie per la gestione del mezzo con cui intende veicolare il suo messaggio nel mondo, che si potrebbe riassumere con questa frase:",
      artistQuote: "Tutti gli uomini e donne di questo pianeta sono degli Artisti, perché posseggono un'anima ed uno spirito divino che gli è stato dato da Dio.",
    },
    identity: {
      eyebrow: "Identità del Token",
      title: "Gli elementi che caratterizzano l'identità del Token USTP",
      items: [
        {
          t: "La sfida aperta all'IA",
          d: "«Universe» sfida la tecnologia super avanzata intesa come intelligenza artificiale a rilasciare o liberare delle emozioni simili o più potenti di quelle di un essere umano.",
        },
        {
          t: "L'IA al servizio dell'uomo",
          d: "USTP vuole inginocchiare l'intelligenza artificiale ai suoi piedi e metterla al suo servizio, senza che essa possa in alcun modo arrivare al punto di prevaricare sugli abitanti del Pianeta Terra, perché questo sarebbe fatale per l'intera umanità.",
        },
        {
          t: "Partnership e cooperazione",
          d: "Lo scopo di «USTP» è quello di lavorare in cooperazione attraverso partnership aziendali ed individuali, per la fruizione del suo messaggio espresso in forma musicale, allo scopo di liberare emozioni in un numero sempre crescente di individui di tutto il mondo.",
        },
        {
          t: "I «fratelli siamesi»",
          d: "Universe verrà supportato da altri brani scritti e prodotti dopo di lui nel corso dei prossimi decenni, che possono essere considerati «fratelli siamesi» di «Universe»; siamesi perché posseggono lo spirito dell'uomo ed una inconfondibile identità e stile artistico, come ognuno di noi possiede.",
        },
      ],
      finalitaTitle: "La finalità",
      finalita: "La finalità di USTP è quella di rendere più consapevoli gli esseri umani delle loro reali capacità e risvegliarle, sfidando l'intelligenza artificiale e tenendola costantemente sotto il suo pieno controllo, dandole ordini precisi e meno potere, poiché, sebbene se ne serva per alleggerire il suo lavoro e rendergli la vita più comoda, riconosce tuttavia che essa è solo una macchina non pensante e nemmeno lontanamente intelligente quanto lo sia un individuo, non possedendo un'anima ed essendo priva della scintilla vitale dello Spirito Divino.",
      ambiziosoTitle: "Un progetto ambizioso",
      ambizioso: "Il progetto Universe è un progetto ambizioso, che non potrà mai cadere o lasciare con il classico «cerino in mano» i possessori del Token quando verrà listato negli Exchange certificati e regolamentati atte allo scambio di criptovalute, perché lo spirito, la creatività e il senso di umana compassione per i suoi simili che lo contraddistinguono gli saranno continuamente d'aiuto per creare nuovi contenuti musicali con le medesime caratteristiche fondamentali di identità artistica, a supporto della sua causa fondamentale: non permettere all'intelligenza artificiale di prevalere in questa sfida del nostro tempo, nella quale l'uomo stesso si è invischiato e ora si trova costretto a dover vincere, se non vuole soccombere in modo irreparabile, in quanto gli eventi prodotti da un disguido tecnico di programmazione o autoprogrammazione di una macchina non pensante fuori controllo sarebbero fatali per l'intero Pianeta Terra.",
      solo: "Solamente un essere umano è capace di sperare ed emozionarsi, lasciando emergere i migliori sentimenti che ha innati, da cui scaturiscono le azioni buone.",
      represents: "Universe rappresenta Speranza e Consapevolezza.",
      battle: "La battaglia ha inizio.",
      successTitle: "I fattori che determinano il successo di USTP sono sostanzialmente due",
      success: [
        "La fruizione del messaggio che contiene Universe e la sfida contro l'incalzante presenza sempre più massiccia dell'intelligenza artificiale nella nostra società, che rischia di prevaricare.",
        "La sincronizzazione della musica su concessione di licenze, in uno o più prodotti (es. film, cortometraggi, pubblicità) con un conseguente aumento della popolarità del Token e dei suoi volumi di scambio.",
      ],
    },
    mission: {
      eyebrow: "Mission",
      title: "MISSION",
      lines: [
        "La tecnologia deve essere al servizio dell'umanità, non il contrario.",
        "USTP nasce per valorizzare la creatività umana, promuovere la cultura e utilizzare l'innovazione tecnologica come strumento di connessione e cambiamento positivo.",
        "In un mondo in cui l'Intelligenza Artificiale si sviluppa a una velocità senza precedenti, USTP vuole contribuire a sensibilizzare le persone sui rischi di un suo utilizzo e sviluppo indiscriminato, affinché il progresso non comprometta la libertà, la dignità, i diritti fondamentali e il valore dell'essere umano.",
        "Crediamo che l'intelligenza artificiale debba rimanere uno strumento al servizio dell'uomo, capace di sostenere la creatività e ampliare le possibilità umane, senza sostituirne la coscienza, la responsabilità e la capacità di creare.",
        "Attraverso la musica, la blockchain e la collaborazione internazionale, USTP intende costruire un progetto che unisca innovazione, consapevolezza e solidarietà, sostenendo iniziative culturali, sociali e umanitarie.",
        "La nostra visione è un futuro in cui il progresso tecnologico contribuisca a costruire un mondo più consapevole, libero, equo e umano.",
      ],
      closing: "USTP — La tecnologia per l'umanità. La creatività per il futuro.",
    },
    collab: {
      eyebrow: "Collaborazioni",
      title: "Collaborazioni",
      p1: "Ogni proposta di contributo creativo per il miglioramento di questo progetto o il suo utilizzo per renderlo ancora più efficace è ben accetta e verrà attentamente vagliata.",
      p2: "Se lo desideri puoi inviare una comunicazione su come migliorare oppure espandere il progetto USTP inviandoci una email a:",
      email: "info@ustp.it",
      cta: "Scrivici una email",
    },
    donations: {
      title: "Donazioni",
      p1: "USTP accetta donazioni di qualsiasi importo, da filantropi, persone comuni, aziende o entità governative o istituzionali che intendano sostenere il progetto.",
      p2: "Puoi inviare la tua donazione al seguente indirizzo di ricezione stable coin USDT.",
      network: "Invia USDT (Tether) su rete Ethereum a:",
      address: "0x07Cab7871407ba4A54B1489E1c24Ee8b932Ba744",
      copy: "Copia indirizzo",
      copied: "Copiato!",
    },
    roadmap: {
      eyebrow: "Roadmap",
      title: "La Roadmap del Token",
      labels: [
        "Fase 1 · Prevendita ai Pionieri",
        "Fase 2 · Diritti Editoriali",
        "Fase 3 · Whitepaper e Legale",
        "Fase 4 · Lancio negli Exchange",
        "Fase 5 · Arrangiamento Audio",
        "Fase 6 · Il Team",
      ],

      intro: "Il programma di USTP si articola in sei prime fasi, che sono fondamentalmente semplici. Ecco le tappe che «Universe» deve intraprendere.",
      badges: { current: "Fase attuale", done: "Completato" },
      items: [
        {
          title: "La distribuzione in prevendita di 7.000.000.000 (sette miliardi) di Token USTP a tutti i sostenitori che abbracciano USTP nella sua fase embrionale.",
        },
        {
          title: "La cessione dei diritti editoriali a due società di Music Publishing italiane.",
        },
        {
          title: "Whitepaper, Tokenomics e aspetti legali.",
          date: "31.01.2027",
          subs: [
            { k: "Whitepaper", v: "Pubblicazione del documento tecnico con obiettivi e dettagli.", done: true, href: "/whitepaper" },
            { k: "Tokenomics", v: "Regolamento di offerta, quantità e distribuzione dei token.", done: true, href: "/tokenomics" },
            { k: "Aspetti legali", v: "Verifica della conformità normativa e societaria." },
          ],
        },
        {
          title: "Creazione pool e lancio del token USTP nei primi Exchange come da programma.",
          subs: [
            { k: "", v: "L'entità della pool e l' offerta circolante sarà dettata dagli esiti del numero di USTP venduti nella fase ICO." },
          ],
        },
        {
          title: "La produzione di una traccia audio (l'arrangiamento di Universe) e la conseguente cessione dei diritti sulle registrazioni agli editori per la riscossione dei proventi derivanti dalla concessione di licenze. Questo punto è già stato realizzato e seguiranno altre ulteriori versioni.",
        },
        {
          title: "La creazione di un team dedicato per ricoprire ruoli di tipo tecnico, amministrativo e legale, nonché i ruoli relativi alla gestione dei mezzi social ed internet. Attualmente il team è formato da due persone.",
        },
      ],
      goals: [
        {
          badge: "Obiettivo 1 · 31.12.2030",
          title: "Il primo obiettivo di USTP in termini matematici",
          text: "Entro il 31 dicembre 2030: raggiungere la quotazione di 1$. Questo è il traguardo che USTP si pone.",
          price: "$1",
          by: "Entro il 31.12.2030",
        },
        {
          badge: "Obiettivo 2 · 31.12.2034",
          title: "Il secondo obiettivo di USTP in termini matematici",
          text: "Entro il 31 dicembre 2034: raggiungere la quotazione di 10$. Questo è il prossimo traguardo che USTP si pone.",
          price: "$10",
          by: "Entro il 31.12.2034",
        },
      ],
    },
    pioneers: {
      eyebrow: "Pionieri",
      title: "I Pionieri detentori di USTP",
      intro: "Universe premia tutti i suoi sostenitori attraverso il suo Token USTP e considera di primaria importanza la sostenibilità finanziaria ed una corretta gestione in termini matematici dello smart contract.",
      phase: "Fase 1 — Come ottenere USTP",
      tierMain: "Per ogni donazione di 460 USDT o multipli ti verranno regalati 70.000.000 (settanta milioni) di USTP, inviati direttamente nel tuo wallet.",
      tierFiat: "La donazione potrà essere effettuata altresì in valuta Fiat: in questo caso la donazione sarà di 400,00 € (o multipli).",
      maxTitle: "Donazione massima",
      maxText: "Ogni pioniere può effettuare donazioni di importo non superiore a 4.600 USDT (o 4.000,00 €), al fine di avere un numero apprezzabile di diversi possessori del Token e non di pochissimi, a maggior garanzia e a beneficio di tutti.",
      examplesTitle: "Esempi di donazione",
      examples: [
        { give: "460 USDT", alt: "oppure 400 €", get: "70 mln di Token in regalo" },
        { give: "920 USDT", alt: "oppure 800 €", get: "140 mln di Token in regalo (centoquaranta milioni)" },
        { give: "4.600 USDT", alt: "oppure 4.000 €", get: "700 mln di Token (settecento milioni)" },
      ],
      excess: "Verranno accettate donazioni spontanee di importo superiore a 4.600 USDT; tuttavia l'eccedenza oltre il tetto massimo non darà diritto a token aggiuntivi in regalo oltre il limite (700 mln) per ogni benefattore.",
      supply: "Il numero disponibile di token per i sostenitori è di 7.000.000.000 (sette miliardi), per una raccolta totale minima di 40.000,00 € (46.000,00 USDT).",
      supplyBadge: "10% della Total Supply riservato ai Pionieri · numero chiuso: 70.000.000.000 USTP",
      counter: {
        title: "Disponibilità token Pionieri",
        remaining: "ancora disponibili",
        claimed: "già distribuiti",
        total: "Su un totale di",
      },
      howEyebrow: "PRE-SELL",
      howTitle: "Come ottenere USTP.",
      howLines: [
        "ICO (Initial Coin Offer) — 1 gennaio 2027.",
        "Distribuzione di 7 mld di USTP.",
        "Potrai riscuotere i tuoi USTP in automatico.",
      ],
      sendTitle: "Invia USDT",
      sendSub: "Invia 460 USDT (o multipli) — su rete Ethereum a questo indirizzo:",
      network: "Rete Ethereum (ERC-20)",
      qrHint: "Scansiona il QR con il tuo wallet per inviare USDT su Ethereum",
      qrModalTitle: "QR del wallet di donazione",
      copy: "Copia",
      copied: "Indirizzo copiato!",
      mailReceipt: "Dopo avere inviato la donazione compila il modulo di invio della ricevuta che trovi qui in basso «Invia la ricevuta della tua donazione» per riscuotere i tuoi token.",
      formTitle: "Invia la ricevuta della tua donazione",
      formSub: "Carica qui lo screenshot della tua donazione: ti contatteremo per consegnarti i Token USTP nel tuo wallet.",
      name: "Nome",
      email: "Email",
      phone: "Numero di telefono cellulare",
      phonePrefix: "Prefisso telefonico",
      phoneInvalid: "Numero di telefono non valido: inserisci solo cifre dopo il prefisso (es. 3401234567)",
      phoneRequired: "Inserisci il numero di telefono cellulare (con prefisso)",
      confirmEmail: "Conferma email",
      emailMismatch: "Le email non corrispondono",
      termsAccept: "Ho letto e accetto i",
      termsLink: "Termini legali",
      termsError: "Accetta i Termini legali per continuare",
      amount: "Importo donato (es. 1380 USDT)",
      txHash: "Hash della transazione (opzionale)",
      fileLabel: "Screenshot della ricevuta",
      fileHint: "Trascina qui il file o clicca per scegliere · PNG, JPG, WEBP o PDF · max 10 MB · obbligatorio",
      fileSelected: "File selezionato",
      submit: "Invia ricevuta",
      sending: "Invio in corso…",
      successMsg: "Ricevuta inviata! Ti contatteremo all'indirizzo email indicato per consegnarti i tuoi Token USTP.",
      successCheck: "Ricevuta inviata con successo",
      errorMsg: "Invio non riuscito. Riprova o scrivi a info@ustp.it",
      altMail: "Per inviare la tua donazione con bonifico o PayPal, inviaci una email a: info@ustp.it, contenente il tuo nome, cognome, numero di telefono. Ti contatteremo per fornirti i dati per accreditare l'importo della tua donazione.",
      notesTitle: "Ulteriori note / informazioni",
      notes: [
        "La distribuzione dei token USTP avverrà in automatico nei wallet dei pionieri attraverso lo scambio \"swap Matic/USTP\" direttamente qui sul nostro sito ufficiale.",
        "Il prezzo durante la fase ICO è di 0,00002636 $ circa, dipende dall'andamento o quotazione di Matic nel momento in cui effettuerai lo swap Matic/USTP.",
        "Una volta che avrai acquistato i tuoi token in prevendita, potrai richiedere l'ingresso al gruppo WhatsApp (e/o Telegram) dedicato, dove verranno rilasciate in tempo reale le notizie più rilevanti e di tuo interesse riguardanti lo sviluppo del programma USTP.",
        "Il quantitativo dei token destinati ai PIONIERI è limitato al 10% della Total Supply.",
      ],
      assetTitle: "Asset",
      assetLead: "L'asset USTP verrà così suddiviso:",
      assetRows: [
        "5% — Team sviluppatore (token già consegnati)",
        "2% — Regali / omaggio ai simpatizzanti",
        "3% — Angel Investors (Pre-ICO)",
        "10% — Fase ICO",
        "10% — Partner music publishing",
        "10% — Soci / partners strategici",
        "10% — Pool di liquidità",
        "10% — Fondo di riserva",
        "40% — Nella disponibilità del Fondatore",
      ],
      assetNames: ["Team sviluppatore", "Regali / omaggio", "Angel Investors", "Fase ICO", "Partner music publishing", "Soci / partners strategici", "Pool di liquidità", "Fondo di riserva", "Fondatore"],
    },
    audio: {
      eyebrow: "La musica",
      title: "USTP ti regala «prima bozza» di Universe",
      sub: "Realizzata a Bari ad aprile 2025 con un pianoforte Yamaha P45 e registrata da uno smartphone.",
      downloadLink: "(Scarica da qui)",
      note: "NB: attualmente abbiamo già altresì realizzato il punto n. 6 della Road Map di cui sopra (un primo arrangiamento). Tutti i Pionieri di USTP che non l'avessero ancora ricevuto potranno farne richiesta del file MP3, per esclusivo ascolto personale.",
    },
    funds: {
      eyebrow: "Trasparenza",
      title: "Come verranno utilizzati i fondi",
      items: [
        "Pagamento o contributi spese per affitti di locali",
        "Pagamento di spese per prestazioni di professionisti, commercialisti, fiscalisti",
        "Pagamento collaboratori, team",
        "Pagamento di bollette, bollettini",
        "Pool di liquidità",
        "Pagamento di tasse",
        "Spese per pagamento di prestazioni di musicisti, arrangiatori e studi di registrazione",
        "Spese per trasporti, carburanti",
        "Spese di rappresentanza, trasferimenti",
        "Spese per consulenze o incarichi di professionisti in tema giuridico e legale",
        "Pagamento di qualsiasi spesa ritenuta necessaria per il compimento delle azioni relative al programma Universe (USTP)",
      ],
    },
    quotes: {
      lead: "Dopo questa descrizione del progetto, concludiamo con una frase:",
      q1: "Forse una musica non potrà cambiare il mondo, ma se vi fosse anche solamente una possibilità su un milione che invece possa essere proprio così, mi sentirei quantomeno in dovere di provarci.",
      a1: "Abacico",
      q2Lead: "Un'altra frase ci ha influenzato nel decidere di voler intraprendere il progetto Universe, ed è questa:",
      q2: "Siate folli.",
      a2: "Steve Jobs",
    },
    faq: {
      eyebrow: "FAQ Pionieri",
      title: "Domande frequenti",
      intro: "Le risposte alle domande più comuni dei Pionieri di USTP.",
      items: [
        {
          q: "Chi è un Pioniere di USTP?",
          a: "Un Pioniere è chi sostiene il progetto USTP effettuando lo scambio (swap) Matic/USTP e riceve i token USTP direttamente nel proprio wallet.",
        },
        {
          q: "Come ricevo i miei token USTP?",
          a: "Potrai riscuotere i tuoi USTP in automatico effettuando lo scambio «swap Matic/USTP» direttamente qui sul nostro sito ufficiale: i token verranno distribuiti nel tuo wallet (ad esempio MetaMask).",
        },
        {
          q: "Su quale rete è pubblicato lo smart contract di USTP?",
          a: "Lo smart contract ufficiale di USTP è pubblicato sulla rete Polygon (MATIC). Puoi consultare l'indirizzo completo del contratto nella pagina «Smart Contract».",
        },
        {
          q: "Quanti token USTP sono disponibili per i Pionieri?",
          a: "Sono disponibili 7 miliardi di USTP, ottenibili tramite lo swap Matic/USTP, fino a esaurimento della riserva destinata ai Pionieri.",
        },
        {
          q: "I token USTP sono un investimento garantito?",
          a: "No. Lo scambio swap Matic/USTP non costituisce un investimento garantito. Il Token USTP sarà collocato esclusivamente attraverso exchange certificati e regolamentati. Valuta sempre con attenzione e secondo la normativa vigente.",
        },
        {
          q: "Come posso contattare il Team di USTP?",
          a: "Puoi scriverci all'indirizzo info@ustp.it oppure unirti al gruppo Telegram ufficiale dei Pionieri che trovi nel footer del sito.",
        },
      ],
    },
    cookie: {
      text: "Utilizziamo solo cookie tecnici e la memoria locale del browser per la lingua: nessun tracciamento. Leggi la",
      policyLink: "Cookie Policy",
      accept: "Accetta",
      refuse: "Rifiuta",
    },
    footer: {
      greeting: "Un caro saluto,",
      team: "Il Team USTP (Universe Score Token Protocol)",
      contact: "Contatti e assistenza",
      disclaimer: "Il Token USTP sarà collocato esclusivamente attraverso exchange certificati e regolamentati per lo scambio di criptovalute. L'acquisto in prevendita non è un investimento garantito: valuta sempre con attenzione e secondo la normativa vigente.",
      rights: "Tutti i diritti riservati.",
      links: [
        { label: "Privacy", href: "/privacy" },
        { label: "Cookie", href: "/cookie" },
        { label: "Assistenza", href: "/assistenza" },
        { label: "Gruppo Telegram Pionieri USTP", href: "https://t.me/+wecbK3Udq_RmMTdk", external: true },
        { label: "Abacico", href: "/abacico" },
        { label: "Team", href: "/team" },
        { label: "Smart Contract", href: "/smart-contract" },
        { label: "Tokenomics", href: "/tokenomics" },
        { label: "White Paper", href: "/whitepaper" },
        { label: "Ottieni Gratis", href: "/ottieni-gratis" },
      ],
      nav: "Indice",
    },
  },
  en: {
    home: {
      title: "Human creativity challenges artificial intelligence.",
    },
    nav: {
      about: "The Manuscript",
      identity: "Identity",
      mission: "Mission",
      donations: "Donations",
      roadmap: "Roadmap",
      pioneers: "Pioneers",
      funds: "Funds",
      faq: "FAQ",
      team: "Team",
      contract: "Smart Contract",
      tokenomics: "Tokenomics",
      cta: "Become a Pioneer",
    },
    hero: {
      eyebrow: "Universe Score Token Protocol · Regulated-market token",
      line1: "Music written",
      line2: "by hand becomes",
      line3accent: "Hope and Awareness.",
      sub: "“Universe” is a musical composition deposited on 4 April 2025. Its token, USTP, challenges artificial intelligence to feel what only a human being can feel.",
      badge: "The battle begins",
      ctaPioneer: "Become a Pioneer",
      ctaScore: "Download the score",
      stats: [
        { v: "70,000,000,000", l: "USTP Total Supply" },
        { v: "7,000,000,000", l: "Pioneer tokens" },
        { v: "No. 22562423", l: "Deposit protocol" },
        { v: "04 · 04 · 2025", l: "Manuscript date" },
      ],
    },
    marquee: [
      "Hope",
      "Awareness",
      "Creativity",
      "The human soul",
      "Original music",
      "The battle begins",
      "Art versus algorithms",
    ],
    banner: {
      warning: "Pioneer Tokens are almost sold out! Only {remaining} USTP remain out of 7,000,000,000: become a Pioneer before the capped number is reached.",
      critical: "Last Pioneer Tokens available! Only {remaining} USTP remain: once capped, no more will be issued.",
      cta: "Become a Pioneer now",
    },
    about: {
      eyebrow: "The Manuscript",
      title: "What is Universe (USTP)?",
      p1: "“Universe” is a musical composition, handwritten in pencil on staff paper.",
      p2: "It is a manuscript that carries within it the traits of every single human being: emotions, feelings.",
      p3: "This piece is instrumental music. It was put on paper on 4 April 2025 and deposited under protocol number 22562423 on the same date.",
      p4: "The score of Universe was later revised and improved to make it nicely readable.",
      scoreLead: "Here it is,",
      scoreLink: "you can find it here",
      depositLabel: "Deposit",
      depositValue: "No. 22562423",
      dateLabel: "Put on paper",
      dateValue: "4 April 2025",
      tokenTitle: "The USTP Token",
      p5: "The USTP Token referenced by Universe has its own history and its own personal vision of things — presumably a fairly shared one — inspired by the rise and the unfortunately runaway growth of artificial intelligence, created by man himself, which threatens the expression of creativity and which, according to “Universe”, will never be able to give emotions comparable to those that only a flesh-and-blood human being can give.",
      p6: "USTP is seeking to create connections and synergies to manage the medium through which it intends to carry its message into the world, which could be summed up with this sentence:",
      artistQuote: "All the men and women of this planet are Artists, because they possess a soul and a divine spirit that was given to them by God.",
    },
    identity: {
      eyebrow: "Token Identity",
      title: "The elements that define the identity of the USTP Token",
      items: [
        {
          t: "The open challenge to AI",
          d: "“Universe” challenges super-advanced technology, meaning artificial intelligence, to release or unleash emotions similar to or more powerful than those of a human being.",
        },
        {
          t: "AI at the service of man",
          d: "USTP wants to bring artificial intelligence to its knees and put it at its service, without it ever being able, in any way, to overpower the inhabitants of Planet Earth, because that would be fatal for all humanity.",
        },
        {
          t: "Partnerships and cooperation",
          d: "The purpose of “USTP” is to work in cooperation through corporate and individual partnerships, for the enjoyment of its message expressed in musical form, in order to unleash emotions in a constantly growing number of people around the world.",
        },
        {
          t: "The “Siamese brothers”",
          d: "Universe will be supported by other pieces written and produced after it over the coming decades, which can be considered “Siamese brothers” of “Universe”; Siamese because they possess the spirit of man and an unmistakable artistic identity and style, just as each of us possesses.",
        },
      ],
      finalitaTitle: "The purpose",
      finalita: "The purpose of USTP is to make human beings more aware of their real abilities and to awaken them, challenging artificial intelligence and keeping it constantly under its full control, giving it precise orders and less power, since — although it makes use of it to lighten its work and make life more comfortable — it nevertheless recognizes that it is only a non-thinking machine, not even remotely as intelligent as a human individual, having no soul and lacking the vital spark of the Divine Spirit.",
      ambiziosoTitle: "An ambitious project",
      ambizioso: "The Universe project is an ambitious project, which will never fall or leave Token holders with the classic “match in hand” when it is listed on certified and regulated exchanges for cryptocurrency trading, because the spirit, creativity and sense of human compassion for its fellow beings that distinguish it will continually help it create new musical content with the same fundamental characteristics of artistic identity, in support of its fundamental cause: not allowing artificial intelligence to prevail in this challenge of our time, in which man himself has become entangled and now finds himself forced to win, lest he succumb irreparably, since the events produced by a technical glitch in the programming or self-programming of a runaway non-thinking machine would be fatal for the entire Planet Earth.",
      solo: "Only a human being is capable of hoping and being moved, letting emerge the best feelings he is born with, from which good actions spring.",
      represents: "Universe represents Hope and Awareness.",
      battle: "The battle begins.",
      successTitle: "The factors that determine the success of USTP are essentially two",
      success: [
        "The enjoyment of the message contained in Universe and the challenge against the relentlessly growing presence of artificial intelligence in our society, which risks overpowering us.",
        "The synchronization of the music under license agreements in one or more products (e.g. films, short films, advertising) with a consequent increase in the Token's popularity and trading volumes.",
      ],
    },
    mission: {
      eyebrow: "Mission",
      title: "MISSION",
      lines: [
        "Technology must serve humanity, not the other way around.",
        "USTP was created to enhance human creativity, promote culture and use technological innovation as a tool for connection and positive change.",
        "In a world where Artificial Intelligence is developing at an unprecedented speed, USTP wants to help raise people's awareness of the risks of its indiscriminate use and development, so that progress does not compromise freedom, dignity, fundamental rights and the value of the human being.",
        "We believe that artificial intelligence must remain a tool at the service of humankind, able to support creativity and expand human possibilities, without replacing its conscience, responsibility and ability to create.",
        "Through music, blockchain and international collaboration, USTP intends to build a project that unites innovation, awareness and solidarity, supporting cultural, social and humanitarian initiatives.",
        "Our vision is a future in which technological progress helps build a more aware, free, fair and human world.",
      ],
      closing: "USTP — Technology for humanity. Creativity for the future.",
    },
    collab: {
      eyebrow: "Collaborations",
      title: "Collaborations",
      p1: "Every proposal for a creative contribution to improve this project, or to use it to make it even more effective, is welcome and will be carefully evaluated.",
      p2: "If you wish, you can send us a message on how to improve or expand the USTP project by emailing us at:",
      email: "info@ustp.it",
      cta: "Email us",
    },
    donations: {
      title: "Donations",
      p1: "USTP accepts donations of any amount, from philanthropists, ordinary people, companies or governmental or institutional entities that wish to support the project.",
      p2: "You can send your donation to the following USDT stablecoin receiving address.",
      network: "Send USDT (Tether) on the Ethereum network to:",
      address: "0x07Cab7871407ba4A54B1489E1c24Ee8b932Ba744",
      copy: "Copy address",
      copied: "Copied!",
    },
    roadmap: {
      eyebrow: "Roadmap",
      title: "The Token Roadmap",
      labels: [
        "Phase 1 · Pioneer Pre-sell",
        "Phase 2 · Publishing Rights",
        "Phase 3 · Whitepaper & Legal",
        "Phase 4 · Launch on Exchanges",
        "Phase 5 · Audio Arrangement",
        "Phase 6 · The Team",
      ],

      intro: "The USTP program is divided into six first phases, which are fundamentally simple. Here are the milestones “Universe” must undertake.",
      badges: { current: "Current phase", done: "Completed" },
      items: [
        {
          title: "The pre-sell distribution of 7,000,000,000 (seven billion) USTP Tokens to all supporters who embrace USTP in its embryonic phase.",
        },
        {
          title: "The assignment of publishing rights to two Italian Music Publishing companies.",
        },
        {
          title: "Whitepaper, Tokenomics and legal aspects.",
          date: "31.01.2027",
          subs: [
            { k: "Whitepaper", v: "Publication of the technical document with goals and details.", done: true, href: "/whitepaper" },
            { k: "Tokenomics", v: "Regulation of the offering, quantity and distribution of tokens.", done: true, href: "/tokenomics" },
            { k: "Legal aspects", v: "Verification of regulatory and corporate compliance." },
          ],
        },
        {
          title: "Pool creation and launch of the USTP token on the first Exchanges as planned.",
          subs: [
            { k: "", v: "The size of the pool and the circulating supply will be determined by the results of the number of USTP sold in the ICO phase." },
          ],
        },
        {
          title: "The production of an audio track (the arrangement of Universe) and the consequent assignment of recording rights to publishers for the collection of proceeds from licensing. This point has already been completed and further versions will follow.",
        },
        {
          title: "The creation of a dedicated team to cover technical, administrative and legal roles, as well as roles related to social media and internet management. Currently the team consists of two people.",
        },
      ],
      goals: [
        {
          badge: "Goal 1 · 31.12.2030",
          title: "USTP's first goal in mathematical terms",
          text: "By 31 December 2030: reach the $1 quotation. This is the milestone USTP sets itself.",
          price: "$1",
          by: "By 31.12.2030",
        },
        {
          badge: "Goal 2 · 31.12.2034",
          title: "USTP's second goal in mathematical terms",
          text: "By 31 December 2034: reach the $10 quotation. This is the next milestone USTP sets itself.",
          price: "$10",
          by: "By 31.12.2034",
        },
      ],
    },
    pioneers: {
      eyebrow: "Pioneers",
      title: "The Pioneers holding USTP",
      intro: "Universe rewards all its supporters through its USTP Token and considers financial sustainability and correct management of the smart contract in mathematical terms of primary importance.",
      phase: "Phase 1 — How to obtain USTP",
      tierMain: "For every donation of 460 USDT or multiples you will be gifted 70,000,000 (seventy million) USTP, sent directly to your wallet.",
      tierFiat: "Donations may also be made in Fiat currency: in this case the donation is €400.00 (or multiples).",
      maxTitle: "Maximum donation",
      maxText: "Each pioneer may donate no more than 4,600 USDT (or €4,000.00), so that there is an appreciable number of different Token holders and not just a few, for greater security and to the benefit of all.",
      examplesTitle: "Donation examples",
      examples: [
        { give: "460 USDT", alt: "or €400", get: "70M Tokens as a gift" },
        { give: "920 USDT", alt: "or €800", get: "140M Tokens as a gift (one hundred forty million)" },
        { give: "4,600 USDT", alt: "or €4,000", get: "700M Tokens (seven hundred million)" },
      ],
      excess: "Spontaneous donations above 4,600 USDT will be accepted; however, the excess beyond the maximum cap will not entitle you to additional gift tokens beyond the limit (700M) per benefactor.",
      supply: "The number of tokens available to supporters is 7,000,000,000 (seven billion), for a minimum total raise of €40,000.00 (46,000.00 USDT).",
      supplyBadge: "10% of the Total Supply reserved for Pioneers · capped at 70,000,000,000 USTP",
      counter: {
        title: "Pioneer token availability",
        remaining: "still available",
        claimed: "already claimed",
        total: "Out of a total of",
      },
      howEyebrow: "PRE-SELL",
      howTitle: "How to get USTP.",
      howLines: [
        "ICO (Initial Coin Offer) — January 1, 2027.",
        "Distribution of 7 billion USTP.",
        "You will be able to collect your USTP automatically.",
      ],
      sendTitle: "Send USDT",
      sendSub: "Send 460 USDT (or multiples) — on the Ethereum network to this address:",
      network: "Ethereum network (ERC-20)",
      qrHint: "Scan the QR code with your wallet to send USDT on Ethereum",
      qrModalTitle: "Donation wallet QR code",
      copy: "Copy",
      copied: "Address copied!",
      mailReceipt: "After sending the donation, fill in the receipt submission module you find below, “Send the receipt of your donation”, to collect your tokens.",
      formTitle: "Send the receipt of your donation",
      formSub: "Upload the screenshot of your donation here: we will contact you to deliver your USTP Tokens to your wallet.",
      name: "First name",
      email: "Email",
      phone: "Mobile phone number",
      phonePrefix: "Phone prefix",
      phoneInvalid: "Invalid phone number: digits only after the prefix (e.g. 3401234567)",
      phoneRequired: "Enter your mobile phone number (with prefix)",
      confirmEmail: "Confirm email",
      emailMismatch: "Emails do not match",
      termsAccept: "I have read and accept the",
      termsLink: "Legal terms",
      termsError: "Please accept the Legal terms to continue",
      amount: "Donated amount (e.g. 1380 USDT)",
      txHash: "Transaction hash (optional)",
      fileLabel: "Receipt screenshot",
      fileHint: "Drag the file here or click to browse · PNG, JPG, WEBP or PDF · max 10 MB · required",
      fileSelected: "Selected file",
      submit: "Send receipt",
      sending: "Sending…",
      successMsg: "Receipt sent! We will contact you at the email address provided to deliver your USTP Tokens.",
      successCheck: "Receipt sent successfully",
      errorMsg: "Sending failed. Please try again or write to info@ustp.it",
      altMail: "To send your donation by bank transfer or PayPal, email us at: info@ustp.it, including your name, surname and phone number. We will contact you to provide the details for crediting your donation.",
      notesTitle: "Further notes / information",
      notes: [
        "USTP tokens will be distributed automatically to the Pioneers' wallets through the \"Matic/USTP swap\" directly here on our official website.",
        "The price during the ICO phase is approximately $0.00002636; it depends on the trend or quotation of Matic at the moment you make the Matic/USTP swap.",
        "Once you have purchased your tokens in the pre-sell, you can request access to the dedicated WhatsApp (and/or Telegram) group, where the most relevant news about the development of the USTP program will be released in real time.",
        "The quantity of tokens reserved for PIONEERS is limited to 10% of the Total Supply.",
      ],
      assetTitle: "Asset",
      assetLead: "The USTP asset will be allocated as follows:",
      assetRows: [
        "5% — Development team (tokens already delivered)",
        "2% — Gifts / giveaways to supporters",
        "3% — Angel Investors (Pre-ICO)",
        "10% — ICO phase",
        "10% — Music publishing partner",
        "10% — Strategic partners / members",
        "10% — Liquidity pool",
        "10% — Reserve fund",
        "40% — Held by the Founder",
      ],
      assetNames: ["Development team", "Gifts / giveaways", "Angel Investors", "ICO phase", "Music publishing partner", "Strategic partners", "Liquidity pool", "Reserve fund", "Founder"],
    },
    audio: {
      eyebrow: "The music",
      title: "USTP gifts you the “first draft” of Universe",
      sub: "Recorded in Bari in April 2025 on a Yamaha P45 piano with a smartphone.",
      downloadLink: "(Download here)",
      note: "NB: we have also already completed point 6 of the Road Map above (a first arrangement). All USTP Pioneers who have not yet received it can request the MP3 file, for personal listening only.",
    },
    funds: {
      eyebrow: "Transparency",
      title: "How the funds will be used",
      items: [
        "Payment or contributions for premises rent",
        "Payment for professional services: accountants, tax advisors",
        "Payment of collaborators, team",
        "Payment of utility bills, payment slips",
        "Liquidity pool",
        "Payment of taxes",
        "Costs for musicians, arrangers and recording studios",
        "Transport and fuel expenses",
        "Representation expenses, transfers",
        "Consulting fees for legal and juridical professionals",
        "Payment of any expense deemed necessary to carry out the actions related to the Universe (USTP) program",
      ],
    },
    quotes: {
      lead: "After this description of the project, we close with a sentence:",
      q1: "Perhaps a piece of music will not change the world, but if there were even just one chance in a million that it actually could, I would feel duty-bound at the very least to try.",
      a1: "Abacico",
      q2Lead: "Another sentence influenced us in deciding to undertake the Universe project, and it is this:",
      q2: "Stay hungry. Stay foolish.",
      a2: "Steve Jobs",
    },
    faq: {
      eyebrow: "Pioneers FAQ",
      title: "Frequently asked questions",
      intro: "Answers to the most common questions from USTP Pioneers.",
      items: [
        {
          q: "Who is a USTP Pioneer?",
          a: "A Pioneer is someone who supports the USTP project by performing the Matic/USTP swap and receives USTP tokens directly in their wallet.",
        },
        {
          q: "How do I receive my USTP tokens?",
          a: "You can collect your USTP automatically by performing the “Matic/USTP swap” directly here on our official website: the tokens will be distributed to your wallet (for example MetaMask).",
        },
        {
          q: "On which network is the USTP smart contract deployed?",
          a: "The official USTP smart contract is deployed on the Polygon (MATIC) network. You can view the full contract address on the “Smart Contract” page.",
        },
        {
          q: "How many USTP tokens are available for Pioneers?",
          a: "7 billion USTP are available, obtainable through the Matic/USTP swap, until the reserve set aside for Pioneers is exhausted.",
        },
        {
          q: "Are USTP tokens a guaranteed investment?",
          a: "No. The Matic/USTP swap is not a guaranteed investment. The USTP Token will be placed exclusively through certified and regulated exchanges. Always evaluate carefully and in accordance with current regulations.",
        },
        {
          q: "How can I contact the USTP Team?",
          a: "You can write to us at info@ustp.it or join the official Pioneers Telegram group linked in the site footer.",
        },
      ],
    },
    cookie: {
      text: "We only use technical cookies and browser local storage for language: no tracking. Read our",
      policyLink: "Cookie Policy",
      accept: "Accept",
      refuse: "Decline",
    },
    footer: {
      greeting: "Warm regards,",
      team: "The USTP Team (Universe Score Token Protocol)",
      contact: "Contacts and assistance",
      disclaimer: "The USTP Token will be placed exclusively through certified and regulated cryptocurrency exchanges. Buying in the pre-sell is not a guaranteed investment: always evaluate carefully and in accordance with current regulations.",
      rights: "All rights reserved.",
      links: [
        { label: "Privacy", href: "/privacy" },
        { label: "Cookie", href: "/cookie" },
        { label: "Support", href: "/assistenza" },
        { label: "USTP Pioneers Telegram Group", href: "https://t.me/+wecbK3Udq_RmMTdk", external: true },
        { label: "Abacico", href: "/abacico" },
        { label: "Team", href: "/team" },
        { label: "Smart Contract", href: "/smart-contract" },
        { label: "Tokenomics", href: "/tokenomics" },
        { label: "White Paper", href: "/whitepaper" },
        { label: "Get Free", href: "/ottieni-gratis" },
      ],
      nav: "Index",
    },
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("it");

  useEffect(() => {
    const supported = ["it", "en"];
    const saved = localStorage.getItem("ustp-lang");
    if (supported.includes(saved)) setLang(saved);
    else if (typeof navigator !== "undefined" && navigator.language) {
      const code = navigator.language.toLowerCase().slice(0, 2);
      setLang(supported.includes(code) ? code : "en");
    }
  }, []);

  const switchTo = (l) => {
    setLang(l);
    localStorage.setItem("ustp-lang", l);
    document.documentElement.lang = l;
  };

  return (
    <LangContext.Provider value={{ lang, setLang: switchTo, t: content[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);

export function getLang() {
  const supported = ["it", "en"];
  if (typeof localStorage !== "undefined") {
    const saved = localStorage.getItem("ustp-lang");
    if (supported.includes(saved)) return saved;
  }
  if (typeof navigator !== "undefined" && navigator.language) {
    const code = navigator.language.toLowerCase().slice(0, 2);
    return supported.includes(code) ? code : "en";
  }
  return "it";
}
